export enum ExpenseCategoryEnum {
  ACCOMMODATION = "ACCOMMODATION",
  MEALS = "MEALS",
  FUEL = "FUEL",
  TOLLS_PARKING = "TOLLS_PARKING",
  COMPANY_OTHER = "COMPANY_OTHER",
}

export function getExpenseCategoryLabel(category: ExpenseCategoryEnum): string {
  const labels: Record<ExpenseCategoryEnum, string> = {
    [ExpenseCategoryEnum.ACCOMMODATION]: "Alojamiento",
    [ExpenseCategoryEnum.MEALS]: "Manutención",
    [ExpenseCategoryEnum.FUEL]: "Combustible",
    [ExpenseCategoryEnum.TOLLS_PARKING]: "Peajes / Parking",
    [ExpenseCategoryEnum.COMPANY_OTHER]: "Gastos de empresa / Otros",
  };
  return labels[category] || category;
}

export const getExpenseCategoryOptions = (): { label: string; value: string }[] => {
  const keys = Object.keys(ExpenseCategoryEnum).filter(
    (key: string) => typeof ExpenseCategoryEnum[key as keyof typeof ExpenseCategoryEnum] === "string"
  );
  return keys.map((val) => {
    const value = ExpenseCategoryEnum[val as keyof typeof ExpenseCategoryEnum];
    return { label: getExpenseCategoryLabel(value), value: value };
  });
};
